import React, { lazy, Suspense, useEffect } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { store } from '~/initializeStore';
import AuthChecker from './components/AuthChecker/AuthChecker';
import Auth from './pages/Auth/Auth';
import ProtectedRoute from '~/components/ProtectedRoute/ProtectedRoute';
import { useTranslation } from 'react-i18next';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import { ExamRoute } from '~/components/ExamRoute/ExamRoute';
const Dashboard = lazy(() => import('~/pages/Dashboard/Dashboard'));
const PresentationView = lazy(() => import('~/pages/PresentationView/PresentationView'));
const PublicSubmission = lazy(() => import('~/pages/PublicSubmission/PublicSubmission'));
const StudentResult = lazy(() => import('~/pages/StudentResult/StudentResult'));

const AppRoutes = () => (
  <AuthChecker>
    <Switch>
      <Route path="/auth" component={Auth} />
      {/* Public student page — signs in anonymously, must not go through ProtectedRoute */}
      <Route path="/submit/:linkId" component={PublicSubmission} exact />
      <ProtectedRoute path="/presentation/:presentationId/view" component={PresentationView} exact />
      <ProtectedRoute path="/" component={Dashboard} />
    </Switch>
  </AuthChecker>
);

const Routes = () => {
  return (
    <>
      <Suspense fallback={<FullPageLoader />}>
        <Switch>
          <Route path="/egzamin/:transactionId" exact>
            <ExamRoute application={<AppRoutes />} result={<StudentResult />} />
          </Route>
          <Route path="/" component={AppRoutes} />
        </Switch>
      </Suspense>
    </>
  );
};

function App() {
  const { i18n } = useTranslation('common');

  useEffect(() => {
    // Force Polish language
    i18n.changeLanguage('pl');
  }, [i18n]);

  return (
    <Provider store={store}>
      <Router>
        <Routes />
      </Router>
    </Provider>
  );
}

export default App;
